/** Where a mapping reads or writes a value in the legacy filters state. */
export const FILTER_TARGET = {
  ROOT: 'root',
  SELECTED_FILTERS: 'selectedFilters'
} as const;

/** Legacy `dateSelectionOption` values a period value maps onto. */
export const DATE_SELECTION_OPTIONS = {
  DATE_RANGE: 'dateRange',
  YEAR_TO_DATE: 'year_to_date',
  CUMULATIVE_TO_DATE: 'cumulative_to_date',
  LAST_PERIOD: 'last_period'
} as const;

/** Legacy period granularities, mirroring the domain's `PERIOD_GRANULARITIES`. */
export const PERIODS = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly'
} as const;

/**
 * Nielsen is a granularity of its own: it stands apart from PERIODS because the legacy
 * period it maps to is a NielsenPeriodIntervalType, whose shape differs from the date based
 * DatePeriodIntervalType.
 */
export const NIELSEN_GRANULARITY = 'nielsen';

/** DB values of the `history` filter definition (FilterDefinitionValue rows). */
export const HISTORY_OPTIONS = {
  PREVIOUS_YEAR: 'n-1',
  CUSTOM: 'perso'
} as const;

/** Legacy `comparisonPeriod.comparisonMode` values the `history` options map onto. */
export const COMPARISON_MODES = {
  PREVIOUS_YEAR: 'previousYear',
  CUSTOM: 'custom'
} as const;

/** Names of the two DB filters that together drive the legacy `comparisonPeriod`. */
export const HISTORY_FIELD = 'history';
export const CUSTOM_HISTORY_FIELD = 'custom_history';

/** Names of the DB filters driving the legacy `selectedPeriod`. */
export const GRANULARITY_FIELD = 'granularity';
export const PERIOD_FIELD = 'period';

/** Identity mapping kept explicit, so an added granularity has to be declared here too. */
export const PERIOD_TO_GRANULARITY_MAP: Record<string, string> = {
  [PERIODS.DAILY]: PERIODS.DAILY,
  [PERIODS.WEEKLY]: PERIODS.WEEKLY,
  [PERIODS.MONTHLY]: PERIODS.MONTHLY,
  [NIELSEN_GRANULARITY]: NIELSEN_GRANULARITY
};
